import React from 'react'
import styled from 'particles/themes/styled'
import Tab, { TabOption } from 'particles/Tab'

const NavbarWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
`

interface NavBarProps {
    className?: string
    selectTab: string
    tabOptions: TabOption[]
    isDisabledClickable: boolean
}

const NavBar: React.FC<NavBarProps> = ({ className, selectTab, tabOptions, isDisabledClickable }) => {
    return (
        <div className={className}>
            <NavbarWrapper>
                <Tab
                    tabItemAlign="left"
                    tabs={tabOptions}
                    selectedTab={selectTab}
                    form="steps"
                    isDisabledClickable={isDisabledClickable}
                />
            </NavbarWrapper>
        </div>
    )
}

export default NavBar
